import { TERRITORY_TO_CONTINENT, type ContinentId, type TerritoryId } from '@qd/map';

export const CONTINENT_OFFSETS: Readonly<Record<ContinentId, { readonly dx: number; readonly dy: number }>> = {
  'north-america': { dx: 0, dy: 0 },
  'europe': { dx: 0, dy: 0 },
  'asia': { dx: 0, dy: 0 },
  'south-america': { dx: 0, dy: 0 },
  'africa': { dx: 0, dy: 0 },
  'australia': { dx: 0, dy: 0 },
};

export function getOffsetCentroid(
  territoryId: TerritoryId,
  baseCentroid: { readonly x: number; readonly y: number }
): { readonly x: number; readonly y: number } {
  const continentId = TERRITORY_TO_CONTINENT[territoryId];
  const offset = continentId ? CONTINENT_OFFSETS[continentId] : { dx: 0, dy: 0 };
  if (!offset) return baseCentroid;
  return {
    x: baseCentroid.x + offset.dx,
    y: baseCentroid.y + offset.dy,
  };
}
